// src/VKCallback.jsx
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

export default function VKCallback({saveToken}) {
    const navigate = useNavigate(); // хук для редиректа
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const device_id = params.get("device_id");
    const code_verifier = localStorage.getItem("code_verifier");
    const savedState = localStorage.getItem("state");
    const utm = localStorage.getItem("utm_source");

    if (state !== savedState) {
      console.error("State mismatch");
      return;
    }

    fetch("https://im-gpt.ru:3000/api/vk/auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, state, device_id, code_verifier,utm }),
    })
      .then(res => res.json())
      .then(data => {
        if(data?.token) 
        {
           saveToken(data.token);
           window.ym(96157357,'reachGoal','3');
        }
        navigate('/chat'); 
      })
      .catch(err => {
        console.error(err);
        navigate('/chat?login'); 
      });
  }, []);

  return <h1>Авторизация VK...</h1>;
}
